<script lang="ts" setup>
import DokkanAnnouncement from "@/components/DokkanAnnouncement.vue";
import TheCommentsCard from "@/components/TheCommentsCard.vue";
import TheLayout from "@/components/TheLayout.vue";
import { PaginatedCommentData } from "@/types";
import { GameAnnouncement } from "@/types/announcement";
import { route } from "ziggy-js";

defineProps<{
  announcement: GameAnnouncement;
  comments: PaginatedCommentData;
}>();
</script>

<template>
  <TheLayout
    :description="announcement.summary"
    :head-image="announcement.banner"
    :heading-href="route('news.index')"
    :title="announcement.title"
    heading="Game News"
  >
    <DokkanAnnouncement :announcement="announcement" class="self-center" />

    <TheCommentsCard
      :commentable-id="announcement.id"
      :comments="comments"
      commentable-type="App\Models\DokkanAnnouncement"
    />
  </TheLayout>
</template>

<style scoped></style>
